module.exports = __webpack_public_path__ + "static/media/brt.68f71dd4.png";